import type { ImageWidget } from "~/types/widgets"

import Image from "~/components/ui/Image"
import { VNode } from "~/constants"
import { isSchedulingActive, type Scheduling } from "~/sdk/contentScheduling"

interface LayoutProps {
  children: VNode
  link?: string
  alt: string
}

export interface Banner {
  /**
   * @title Banner
   */
  image: ImageWidget

  /**
   * @title Texto Alternativo do banner
   */
  alt: string

  /**
   * @title Link de direcionamento
   */
  link?: string
  /**
   * @title Agendamento
   * @description Deixe este campo vazio para manter sempre visível
   */
  scheduling?: Scheduling
}

export interface Props {
  /**
   * @title Banners
   * @description Limitado a 5 banners
   */
  banners: Banner[]
}

const Layout = ({ children, link, alt }: LayoutProps) => {
  const commonClass =
    'w-full max-w-[340px] min-w-[340px] md:min-w-min rounded-xl overflow-hidden snap-start group'

  if (!!link && link !== '') {
    return (
      <a href={link} aria-label={alt} className={commonClass}>
        {children}
      </a>
    )
  }

  return <div className={commonClass}>{children}</div>
}

export default function BrandBannerMosaic({ banners }: Awaited<ReturnType<typeof loader>>) {
  if (!banners?.length) return null

  return (
    <div className='w-full max-w-[1834px] mt-12 mx-auto px-4'>
      <div className='flex items-center md:justify-center gap-2 lg:gap-6 w-full overflow-x-scroll md:overflow-x-hidden snap-x snap-mandatory'>
        {banners.map((banner, i) => {
          if (!isSchedulingActive(banner.scheduling)) return null
          const image = banner.image
          const alt = banner.alt
          const link = banner.link

          if (!image || !alt) return null

          return (
            <Layout link={link} alt={alt} key={`${alt}-${i}`}>
              <Image
                src={image}
                className='w-full h-full object-cover max-w-full min-w-full duration-500 group-hover:scale-105'
                width={340}
                height={400}
                alt={alt}
              />
            </Layout>
          )
        })}
      </div>
    </div>
  )
}

export const loader = (props: Props) => {
  const banners = props.banners?.slice(0, 5)
  return { ...props, banners }
}
